import { render, staticRenderFns } from "./TipoDeEmpresa.vue?vue&type=template&id=27fa9421&"
import script from "./TipoDeEmpresa.vue?vue&type=script&lang=js&"
export * from "./TipoDeEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports